const SpacingFoundationsThemes = {
    spacing_00: '0rem',
    spacing_25: '0.0625rem',
    spacing_50: '0.125rem',
    spacing_75: '0.1875rem',
    spacing_100: '0.25rem',
    spacing_125: '0.375rem',
    spacing_150: '0.5rem',
    spacing_200: '0.75rem',
    spacing_250: '1rem',
    spacing_300: '1.5rem',
    spacing_350: '2rem',
    spacing_400: '2.5rem',
    spacing_450: '3rem',
    spacing_500: '3.5rem',
    spacing_550: '4rem',
    spacing_558: '5.25rem',
    spacing_575: '7.5rem',
    spacing_600: '8rem',
    spacing_negative_100: '-0.25rem',
    spacing_negative_150: '-0.5rem',
    spacing_negative_200: '-0.75rem',
    spacing_negative_250: '-1rem',
    spacing_negative_300: '-1.5rem',
    spacing_negative_350: '-2rem',
    spacing_negative_400: '-4rem',
};
export { SpacingFoundationsThemes };
//# sourceMappingURL=spacing-foundations.themes.js.map